import {eventCreate, eventUpdate, eventUpdateShortDescription} from "./eventApi";

export const eventCreateAction = async ({ request }) => {
    const formData = await request.formData();
    const submission = {
        label: formData.get("label"),
        startDate: formData.get("startDate"),
        endDate: formData.get("endDate"),
        startTime: formData.get("startTime"),
        endTime: formData.get("endTime"),
        eventTypeEntityId: formData.get("eventTypeEntityId"),
        shortDescription: formData.get("shortDescription"),
    };
    return await eventCreate(submission);
};

export const eventUpdateAction = async ({ request }) => {
    const formData = await request.formData();
    const eventEntityId = formData.get("eventEntityId");

    const submission = {
        eventEntityId,
        label: formData.get("label"),
        eventTypeEntityId: formData.get("eventTypeEntityId"),
        startDate: formData.get("startDate"),
        endDate: formData.get("endDate"),
        startTime: formData.get("startTime"),
        endTime: formData.get("endTime"),
    };

    const res = await eventUpdate({ ...submission });

    if (res.code === "SUCCESS") {
        const oldShortDescription = formData.get("oldShortDescription");
        const newShortDescription = formData.get("shortDescription");
        if (newShortDescription !== oldShortDescription) {
            await eventUpdateShortDescription(eventEntityId, newShortDescription);
        }
    }
    return res;
};
